/* istanbul ignore file */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { getCompanyData } from '../shared/constants/companies';
const companyData = getCompanyData();

export const availableLanguages = Object.keys(companyData.translationsResources);
const getLanguage = () =>
    (navigator.languages &&
        navigator.languages.length &&
        navigator.languages[0]) ||
    navigator.language ||
    'en';

i18n.use(initReactI18next).use(LanguageDetector).init({
    resources: companyData.translationsResources,
    defaultNS: 'common',
    lng: getLanguage(),
    fallbackLng: 'en',
    interpolation: {
        defaultVariables: {
            company: companyData.translationsVariables
        }
    }
});

export default i18n;
